import {
    ADD_SCHOOLS_FAIL,
    ADD_SCHOOLS_SUCCESS,
    DELETE_SCHOOLS_FAIL,
    DELETE_SCHOOLS_SUCCESS,
    BULK_DELETE_SCHOOLS_FAIL,
    BULK_DELETE_SCHOOLS_SUCCESS,
    EXPORT_SCHOOLS_FAIL,
    EXPORT_SCHOOLS_SUCCESS,
    GET_SCHOOLS_DETAILS_FAIL,
    GET_SCHOOLS_DETAILS_SUCCESS,
    GET_SCHOOLS_LISTING_FAIL,
    GET_SCHOOLS_LISTING_SUCCESS,
    RESET_SCHOOLS_ATTACHMENT_STATE,
    RESET_SCHOOLS_STATE,
    UPDATE_SCHOOLS_FAIL,
    UPDATE_SCHOOLS_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    schoolsListing: [],
    schoolsDetails: [],
    addSchools: [],
    updateSchools: [],
    deleteSchools: [],
    bulkDeleteSchools: [],
    exportSchools: [],
    error: [],
}

const Schools = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_SCHOOLS_LISTING_SUCCESS:
            return {
                ...state,
                schoolsListing: action.payload
            }
        case GET_SCHOOLS_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_SCHOOLS_DETAILS_SUCCESS:
            return {
                ...state,
                schoolsDetails: action.payload
            }
        case GET_SCHOOLS_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_SCHOOLS_SUCCESS:
            return {
                ...state,
                addSchools: action.payload
            }
        case ADD_SCHOOLS_FAIL:
            return {
                ...state,
                error: action.payload,
                addSchools: action.payload,
            }

        case UPDATE_SCHOOLS_SUCCESS:
            return {
                ...state,
                updateSchools: action.payload
            }
        case UPDATE_SCHOOLS_FAIL:
            return {
                ...state,
                error: action.payload,
                updateSchools: action.payload,
            }

        case DELETE_SCHOOLS_SUCCESS:
            return {
                ...state,
                deleteSchools: action.payload
            }
        case DELETE_SCHOOLS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case BULK_DELETE_SCHOOLS_SUCCESS:
            return {
                ...state,
                bulkDeleteSchools: action.payload
            }
        case BULK_DELETE_SCHOOLS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_SCHOOLS_SUCCESS:
            return {
                ...state,
                exportSchools: action.payload
            }
        case EXPORT_SCHOOLS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_SCHOOLS_STATE:
            return {
                ...state,
                schoolsListing: [],
                schoolsDetails: [],
                addSchools: [],
                updateSchools: [],
                deleteSchools: [],
                bulkDeleteSchools: [],
                exportSchools: [],
                error: [],
            }
        case RESET_SCHOOLS_ATTACHMENT_STATE:
            return {
                ...state,
                exportSchools: [],
                error: [],
            }
        default:
            return state
    }
}

export default Schools
